module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper wrapper-content"
  }, [_c('div', {
    staticClass: "row animated fadeInUp"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('filebox-list', {
    attrs: {
      "icons": _vm.icons,
      "myFiles": _vm.myFiles,
      "companyFiles": _vm.companyFiles,
      "loadingMyFiles": _vm.loadingMyFiles,
      "loadingCompanyFiles": _vm.loadingCompanyFiles
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78cf34f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/filebox/FileboxDashboard.vue
// module id = 3348
// module chunks = 3